import * as React from "react";

import { Button, Kbd, KbdGroup } from "@/components/ui";

import { TRANSCRIPT_SHORTCUT } from "./qaStudio";
import { ShortcutRow } from "./studioChrome";

export function ShortcutsOverlay({
  readOnly,
  modKey,
  onClose,
}: {
  readOnly?: boolean;
  modKey: string;
  onClose: () => void;
}) {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-black/30 p-6" onClick={onClose}>
      <div
        role="dialog"
        aria-label="Keyboard shortcuts"
        className="w-full max-w-lg rounded-xl border border-slate-200 bg-white p-4 text-sm text-slate-700 shadow-lg dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
        onClick={event => event.stopPropagation()}
      >
        <div className="mb-3 flex items-center justify-between">
          <strong className="text-slate-800 dark:text-slate-100">Shortcuts</strong>
          <Button type="button" size="xs" variant="ghost" title="Close (Esc)" onClick={onClose}>
            Close
          </Button>
        </div>
        <ul className="grid grid-cols-1 gap-2 text-slate-600 sm:grid-cols-2 dark:text-slate-300">
          <ShortcutRow label="Play/pause">
            <Kbd>Space</Kbd>
            <Kbd>K</Kbd>
          </ShortcutRow>
          <ShortcutRow label="Skip 2s">
            <Kbd>J</Kbd>
            <Kbd>L</Kbd>
            <Kbd>←</Kbd>
            <Kbd>→</Kbd>
          </ShortcutRow>
          <ShortcutRow label="Previous / next issue">
            <Kbd>↑</Kbd>
            <Kbd>↓</Kbd>
          </ShortcutRow>
          <ShortcutRow label="Playback speed">
            <Kbd>&lt;</Kbd>
            <Kbd>&gt;</Kbd>
          </ShortcutRow>
          <ShortcutRow label="Transcript">
            <Kbd>{TRANSCRIPT_SHORTCUT}</Kbd>
          </ShortcutRow>
          {readOnly ? null : (
            <>
              <ShortcutRow label="Flag at playhead">
                <Kbd>1</Kbd>
                <span>–</span>
                <Kbd>5</Kbd>
              </ShortcutRow>
              <ShortcutRow label="Edit / leave comment">
                <Kbd>Enter</Kbd>
              </ShortcutRow>
              <ShortcutRow label="Remove flag">
                <Kbd>Backspace</Kbd>
              </ShortcutRow>
              <ShortcutRow label="Send back / approve">
                <KbdGroup>
                  <Kbd>{modKey}</Kbd>
                  <Kbd>Enter</Kbd>
                </KbdGroup>
              </ShortcutRow>
            </>
          )}
          <ShortcutRow label="Close shortcuts">
            <Kbd>Esc</Kbd>
          </ShortcutRow>
        </ul>
      </div>
    </div>
  );
}
